import React from 'react';
import {
  Box, Typography, Grid, TextField, List, ListItem,
  ListItemText, IconButton, Tooltip, Divider
} from '@mui/material';
import {
  MiscellaneousServices, Add, Delete
} from '@mui/icons-material';

const ServicesOfferedStep = ({
  formik,
  textFieldStyles,
  addItem,
  removeItem
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#f9f9f9',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        margin: 'auto'
      }}
    >
      <Typography
        variant='h5'
        gutterBottom
        sx={{
          color: '#1976d2',
          textAlign: 'center',
          mb: 3,
          fontWeight: 'bold'
        }}
      >
        <MiscellaneousServices sx={{ verticalAlign: 'middle', mr: 1 }} />
        Services Offered
      </Typography>

      {/* Input Fields for Adding New Service */}
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={5} sm={5}>
          <TextField
            label='Service Name'
            name='newService.name'
            value={formik.values.newService?.name || ''}
            onChange={formik.handleChange}
            fullWidth
            required
            sx={textFieldStyles}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <TextField
            label='Description (Optional)'
            name='newService.description'
            value={formik.values.newService?.description || ''}
            onChange={formik.handleChange}
            fullWidth
            multiline
            rows={2}
            sx={{
              backgroundColor: 'rgba(212, 212, 212, 0.56)',
              marginTop: '1em',
              borderRadius: '5px',
              borderBottom: '1.5px solid #bdd1e0',
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#6794b6' },
                '&.Mui-focused fieldset': { borderColor: '#3b76a2' }
              },
              '& .MuiInputLabel-root': { color: '#13334c', fontSize: { xs: '0.9em', sm: '1em' } },
              '& .MuiInputLabel-root.Mui-focused': { color: '#13334c' },
              '& .MuiOutlinedInput-input': { color: '#000000', fontSize: { xs: '0.95em', sm: '1em' }, padding: { xs: '0.85em 0.5em', sm: '0.7em 0.5em' } }
            }}
          />
        </Grid>
        <Grid item xs={1} sm={1} sx={{ textAlign: 'center' }}>
          <Tooltip title='Add Service'>
            <IconButton
              color='primary'
              onClick={() => {
                if (formik.values.newService?.name?.trim()) {
                  addItem('services_offered', { ...formik.values.newService });
                  formik.setFieldValue('newService', { name: '', description: '' });
                }
              }}
            >
              <Add />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      {/* Display List of Added Services */}
      {formik.values.services_offered.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Typography variant='h6' sx={{ mb: 1 }}>Added Services:</Typography>
          <List sx={{ backgroundColor: '#f8f8f8', borderRadius: '8px', padding: '10px', color: '#000000' }}>
            {formik.values.services_offered.map((service, index) => (
              <React.Fragment key={index}>
                <ListItem
                  secondaryAction={
                    <Tooltip title='Remove Service'>
                      <IconButton color='error' onClick={() => removeItem('services_offered', index)}>
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  }
                >
                  <ListItemText
                    primary={service.name}
                    secondary={service.description || 'No description provided'}
                    secondaryTypographyProps={{ sx: { color: '#555' } }}
                  />
                </ListItem>
                {index < formik.values.services_offered.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default ServicesOfferedStep;
